var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 111,
    viewBox: "0 0 113 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1191 11.9054L32.1195 11.905C38.9091 5.809 47.558 2.45022 56.5025 2.42041C74.7058 2.42167 89.8432 16.5113 91.491 34.7274L91.5974 35.9043L92.7665 36.0763C103.276 37.6228 111.5 46.7949 111.5 58.0795C111.5 70.4769 101.581 80.3095 89.609 80.3095H61.4242V46.5968L74.1055 59.7142C74.1064 59.7151 74.1073 59.716 74.1082 59.717C75.0472 60.6933 76.3332 61.2534 77.6875 61.2534C79.043 61.2534 80.3302 60.6922 81.2695 59.7142C82.2068 58.7383 82.7232 57.4271 82.7232 56.072C82.7232 54.7169 82.2068 53.4058 81.2695 52.4298L60.0833 30.3706C59.6189 29.8858 59.0638 29.4978 58.4483 29.2318C57.8327 28.9658 57.1704 28.828 56.5 28.828C55.8296 28.828 55.1673 28.9658 54.5517 29.2318C53.9362 29.4978 53.3811 29.8858 52.9167 30.3706L31.7305 52.4298C30.7932 53.4058 30.2768 54.7169 30.2768 56.072C30.2768 57.4271 30.7932 58.7383 31.7305 59.7142C32.6698 60.6922 33.957 61.2534 35.3125 61.2534C36.6671 61.2534 37.9534 60.693 38.8925 59.7162C38.8932 59.7156 38.8938 59.7149 38.8945 59.7142L51.5758 46.5968V80.3095H26.7033C12.903 80.3095 1.5 68.9772 1.5 54.7337C1.5 42.4739 9.95288 32.3397 21.1139 29.7743L22.1002 29.5476L22.2592 28.5481C23.2024 22.6214 26.8983 16.5891 32.1191 11.9054Z",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7917 80.0898V109H61.2084V80.5346",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.5621e4572b068cde474d54d700f8e9dc.svg";
export { ForwardRef as ReactComponent };